import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { PullDownContainerComponent } from './pull-down-container.component'

@NgModule({
  declarations: [PullDownContainerComponent],
  imports: [CommonModule],
  exports: [PullDownContainerComponent],
})
export class PullDownContainerModule {}
